var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ 'disable' : !_vm.isClick},staticStyle:{"height":"400px"},attrs:{"id":"main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }